import React from 'react';

import './style.scss';

export interface ISearchLoaderProps {
  size: number;
}

const SearchLoader: React.FunctionComponent<ISearchLoaderProps> = ({ size }) => {
  const sizeInPx = `${size}px`;

  const styles: React.CSSProperties = {
    height: sizeInPx,
    width: sizeInPx,
    backgroundSize: sizeInPx,
  };

  return <div className="search-loader" style={styles} />;
};

export default SearchLoader;
